/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/campaign', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, payload);
  }
}

export default new ElectoralCampaignAPI();
